import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  return {
    listWrapper: css`
      width: 100%;
    `,
    chooseFilter: isSelected => css`
      position: relative; // Needed for positioning the visually-hidden input
      display: flex;
      justify-content: space-between;
      gap: 1rem;
      align-items: center;
      padding: 8px 8px 8px 12px;
      border-radius: 80px;
      margin-bottom: 0.25rem;
      cursor: pointer; // Indicates the label is clickable

      span {
        color: ${colors.darkGrey};
        letter-spacing: 0.32px;
      }
      &:hover {
        background-color: ${colors.lightGrey};
      }

      ${breakpoints.s} {
        &:has(input:focus-visible) {
          border: 2px solid ${colors.border_black};
          outline: 2px solid ${colors.skip_yellow};
        }
      }

      ${isSelected &&
      css`
        background-color: ${colors.lightGrey};
      `}
    `,
    optionCheckbox: css`
      // Visually hide the native checkbox but keep it accessible
      position: absolute;
      opacity: 0;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;

      // Style the checkmark's parent container
      & + span {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 100%;
        color: ${colors.darkGrey};
        border: 2px solid currentColor;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // Style the checked state of the visual checkbox
      &:checked + span {
        color: ${colors.surfaceBlue};
        background-color: ${colors.white};
      }

      // Style the visual checkmark via a pseudo-element on the adjacent span
      &:checked + span::after {
        content: '';
        width: 0.25rem;
        height: 0.625rem;
        border: solid currentColor;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: relative;
        display: block; // Make the checkmark visible when checked
        margin-top: -3px;
      }
    `,
  };
};
